export const styles = {
  spanCursor: { cursor: 'pointer' },
};
